<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.reasonCode" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.reasonName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="reasonCode" label="编码" width="140" />
      <el-table-column prop="reasonName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="类型" width="100" align="center">
        <template slot-scope="{ row }">{{ row.reasonType === '01' ? '故障' : '其它' }}</template>
      </el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.reasonId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.reasonId ? '修改停机原因' : '新增停机原因'" :visible.sync="visible" width="480px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="编码" prop="reasonCode"><el-input v-model="form.reasonCode" /></el-form-item>
        <el-form-item label="名称" prop="reasonName"><el-input v-model="form.reasonName" /></el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.reasonType" style="width:100%">
            <el-option label="故障" value="01" />
            <el-option label="其它" value="02" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listStoppageReason, getStoppageReason, saveStoppageReason, updateStoppageReason, deleteStoppageReason
} from '../../api/stoppageReason'

function emptyForm() {
  return { reasonId: '', reasonCode: '', reasonName: '', reasonType: '02', active: '1', remark: '', version: 0 }
}

export default {
  name: 'StoppageReasonPage',
  components: { ListPagination },
  data() {
    return {
      query: { reasonCode: '', reasonName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, form: emptyForm(),
      rules: {
        reasonCode: [{ required: true, message: '请填写编码', trigger: 'blur' }],
        reasonName: [{ required: true, message: '请填写名称', trigger: 'blur' }]
      }
    }
  },
  created() { this.load() },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listStoppageReason({
        currentPage: this.page, pageSize: this.pageSize,
        reasonCode: this.query.reasonCode, reasonName: this.query.reasonName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getStoppageReason(id).then(res => { this.form = Object.assign(emptyForm(), res.data || {}) })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.reasonId ? updateStoppageReason(this.form) : saveStoppageReason(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(row) {
      this.$confirm('确定删除？', '提示', { type: 'warning' }).then(() => {
        deleteStoppageReason([row.reasonId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
